import logo from "./logo.svg";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import Login from "./views/login";
import MyDesigns from "./views/my-design";
import RegisterPage from "./views/register";
import HomePage from "./views/home";
import MyAccount from "./views/my-account";
import PricingPage from "./views/pricing";
import { Toaster } from "react-hot-toast";
import FieldEditor3 from "./components/fieldEditor3.tsx";
import AccessDenied from "./components/AccessDenied.tsx";
import GuideBookPage from "./views/guidebook";
import InvitationPage from "./views/invitationPage";
import { SupportWidget } from "./components/supportWidget/supportWidget.tsx";
import MobileDisabled from "./views/mobileDisabled";
import PasswordReset from "./views/resetPassword";
import PasswordResetConfirmation from "./views/passwordResetPage";
import OnboardingAccountSetup from "./views/account-setup.tsx";
import PrivacyPolicy from "./views/privacy-policy";
import TermsAndConditions from "./views/terms-and-conditions";
import DrillFloFreeLandingPage from "./views/SEO-Pages/drillflo-free";
import DrillFloOnlineFreeLandingPage from "./views/SEO-Pages/drillflo-online-free";
import TemplateLanding from "./views/templateLanding";
import AllTemplatesPage from "./views/templatesPage";
import Tracker from '@openreplay/tracker';
import { ensureRemoteConfig } from "./services/firebase";
import { isEmulatorMode } from "./services/evalMode.js";
import DrillFloOnboardingExperience from "./components/OnboardingFlow/DrillFloOnboardingExperience.tsx";

// Eval stack: no OpenReplay tracker (window.tracker stays undefined; consumers null-check it).
const tracker = isEmulatorMode ? null : new Tracker({
  projectKey: "6OELMkUoXv5QGOYEOnbH",
  __DISABLE_SECURE_MODE: window.location.hostname === "localhost"
});

window.tracker = tracker;

function App() {
  if (tracker) tracker.start();
  ensureRemoteConfig();

  return (
    <div className="h-screen ">
      <Toaster />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/marching-band-drill-design-software"
          element={<HomePage />}
        />
        <Route path="/login" element={<Login />} />
        <Route
          path="/why-is-drillflo-the-best-free-drill-design-software"
          element={<DrillFloFreeLandingPage />}
        />
        <Route
          path="/free-online-drill-writing-software"
          element={<DrillFloOnlineFreeLandingPage />}
        />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/templates" element={<AllTemplatesPage />} />
        <Route path="/templates/:templateId" element={<TemplateLanding />} />
        <Route path="/reset-password" element={<PasswordReset />} />
        <Route path="/mobile-disabled" element={<MobileDisabled />} />
        <Route
          path="/access-denied"
          element={<AccessDenied message="You don't have Access" />}
        />
        <Route path="/my-designs" element={<MyDesigns />} />
        <Route
          path="/welcome-to-drillflo"
          element={<OnboardingAccountSetup />}
        />
        <Route path="/onboarding-account-setup" element={<DrillFloOnboardingExperience />} />
        <Route path="/my-account" element={<MyAccount />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />

        <Route path="/pricing" element={<PricingPage />} />

        <Route path="/guidebook" element={<GuideBookPage />} />
        <Route
          path="/reset-password-confirmation"
          element={<PasswordResetConfirmation />}
        />

        <Route path="/designs/:slug" element={<FieldEditor3 />} />
        <Route path="/invitation" element={<InvitationPage />} />
        {/* <Route path="/about" element={<About />} /> */}
      </Routes>

      <SupportWidget />
    </div>
  );
}

export default App;
